export const GENERAL_KEYS = new Set<string>([
	"edit_instruction",
	"short_description",
	"background_setting",
	"style_medium",
	"context",
	"artistic_style",
]);

export enum STRUCTURED_PROMPT_VIEW_MODES {
	STRUCTURE = "structure",
	JSON_SOURCE = "json_source",
	DELTA_PROMPT = "delta_prompt",
}

export const FIBO_DEFAULT_STEPS = 50;
export const FIBO_DEFAULT_NUM_RESULTS = 4;
